/**
 * Отказ записи избранного §6.6 назван, а не молчит — тот же довод, что у
 * `pinToggleNotice`. Несёт монету (review stage6-favorites, п. 5): общая
 * полоса над списком обязана называть, о какой монете речь, а панель —
 * показывать отказ только тогда, когда он о её собственной монете, а не о
 * последнем нажатии где-то ещё в таблице.
 *
 * Два вида отказа, а не один (review, п. 4): `400` — демон отверг саму
 * запись, и повторный запрос тем же ключом отклонится тем же способом, а
 * временная недоступность хранилища — тот случай, где «попробуйте ещё раз»
 * осмысленно. «Такой записи уже нет» здесь не наступает вовсе: снятие
 * избранного идемпотентно на стороне демона (design.md решение 3).
 *
 * Модуль отдельный от `density-screen.tsx` (review stage6-favorites, второй
 * круг, п. 5): `density-detail-content.tsx` и `density-detail-panel.tsx`
 * несут содержимое панели, которую сам экран монтирует, и их импорт из
 * `density-screen.tsx` замыкал бы цикл модулей.
 */
export type FavoriteToggleNotice = { kind: "invalid" | "retry"; base: string } | null;

export function favoriteToggleNotice(
  status: "ok" | "invalid" | "unavailable",
  base: string,
): FavoriteToggleNotice {
  if (status === "ok") {
    return null;
  }
  return { kind: status === "invalid" ? "invalid" : "retry", base };
}

/** Текст уведомления §6.6 — общий для полосы над списком и панели. */
export function favoriteToggleNoticeText(notice: NonNullable<FavoriteToggleNotice>): string {
  return notice.kind === "invalid"
    ? `Демон отверг запись избранного ${notice.base}.`
    : `Избранное ${notice.base} не сохранилось — попробуйте ещё раз.`;
}

/**
 * Уведомление после старта или успеха действия избранного монеты `base`:
 * гасит только своё, чужое не трогает (review stage6-favorites, второй круг,
 * п. 3). Старт действия по монете X не имеет права стереть ещё не прочитанный
 * отказ по монете Y, и успех действия по X — тоже: отказ Y остаётся видимым,
 * пока его не закроют явно или не заменит новый отказ той же монеты Y.
 */
export function clearFavoriteNoticeForBase(
  previous: FavoriteToggleNotice,
  base: string,
): FavoriteToggleNotice {
  return previous !== null && previous.base !== base ? previous : null;
}
